/* Versão atual do Sisare Web */
export const APP_VERSION = '1.0.0.10'; // alterar a cada nova publicação/release 11/10/2026